import { useDedaloApi } from '@/hooks/api/useDedaloApi';
import {
    ThesaurusTermSchema,
    ThesaurusTreeSchema,
    ThesaurusCheckTermSchema,
    ThesaurusBlockSchema,
    ThesaurusChildrenSchema,
    ThesaurusAreaSchema,
    InformeSchema
} from '@/schemas/thesaurusSchema';

export function useThesaurusTerm(id) {
    const options = {
        table: 'ts_mujer_y_memoria',
        ar_fields: ['term', 'term_id', 'web_path', 'uri'],
        section_id: id,
        order: 'norder ASC',
    };

    return useDedaloApi(options, ThesaurusTermSchema);
}

export function useInforme() {
    const options = {
        table: 'ts_mujer_y_memoria',
        ar_fields: ['term', 'pdf_resolved'],
        section_id: 36,
    };

    return useDedaloApi(options, InformeSchema);
}

export function useThesaurusTree() {
    const options = {
        table: 'ts_mujer_y_memoria',
        ar_fields: ['term', 'term_id', 'web_path', 'parent', 'uri', 'pdf_resolved'],
        sql_filter: "parents LIKE '%navarra451_1%' AND menu = 'yes'",
        order: 'norder ASC',
    };

    return useDedaloApi(options, ThesaurusTreeSchema);
}

export function useThesaurusCheckTerm(slug) {
    const options = {
        table: 'ts_mujer_y_memoria',
        ar_fields: ['term_id', 'parents'],
        sql_filter: `web_path = '${slug}'`,
    };

    return useDedaloApi(options, ThesaurusCheckTermSchema);
}

export function useThesaurusBlock(id) {
    const options = {
        table: 'ts_mujer_y_memoria',
        ar_fields: ['term', 'abstract', 'body', 'image'],
        resolve_portals_custom: '{"image": "image"}',
        section_id: id,
    };

    return useDedaloApi(options, ThesaurusBlockSchema);
}

export function useThesaurusChildren(termId) {
    const options = {
        table: 'ts_mujer_y_memoria',
        ar_fields: ['term', 'term_id', 'web_path'],
        order: 'norder ASC',
        sql_filter: `parent = '${termId}'`,
    }

    return useDedaloApi(options, ThesaurusChildrenSchema);
}

export function useThesaurusArea(id) {
    const options = {
        table: 'ts_mujer_y_memoria',
        ar_fields: ['term', 'abstract', 'body', 'image', 'indexations', 'uri', 'bibliography_data', 'documents_indexation'],
        resolve_portals_custom: '{"image": "image", "bibliography_data": "bibliographic_references"}',
        section_id: id,
    };

    return useDedaloApi(options, ThesaurusAreaSchema);
}